import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { PaymentNetInputPageFlatFields } from 'src/app/RegisterAccount/RegisterAccount'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgUpdate from 'src/components/Svgs/SvgUpdate'
import { useTranslate } from 'src/localization/Trns'
import { IssuerIntegratorListModel } from 'src/models/issuerIntegrator.models'
import { css } from 'styled-components'

interface RegisterAccountCardInfoJPMProps {
  className?: string
  paymentNetInputPageFlatFields?: PaymentNetInputPageFlatFields
  selectedIssuer?: IssuerIntegratorListModel
  returnToCardInformation: () => void
}

const RegisterAccountCardInfoJPM: React.FC<RegisterAccountCardInfoJPMProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  return (
    <div
      className={props.className}
      css={css`
        display: flex;
        width: 580px;
        padding: 40px;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        border-radius: 10px;
        border: 1px solid ${themeConstants.colors.cta};
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: flex-start;
          border-radius: 3px;
          display: flex;
          gap: 40px;
          align-self: stretch;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 12px;
            flex: 1 0 0;
          `}
        >
          {props.selectedIssuer?.url === undefined ? (
            <span
              id={props.selectedIssuer?.name + ' Img'}
              css={css`
                width: 80px;
                padding: 12px 8px;
                border-radius: 3px;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
                ${getFontCss(
                  12,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.regular,
                )};
              `}
            >
              {props.selectedIssuer?.name}
            </span>
          ) : (
            <img
              id={props.selectedIssuer.name + ' Img'}
              css={css`
                width: 80px;
                padding: 12px 8px;
                border-radius: 3px;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
              `}
              src={props.selectedIssuer.url}
              alt={props.selectedIssuer.name}
            />
          )}
          <span
            css={css`
              ${getFontCss(
                20,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )};
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              margin-bottom: 8px;
            `}
          >
            {props.selectedIssuer?.name}
          </span>
        </div>
        <HoverableLink
          css={css`
            display: flex;
            align-items: center;
          `}
          onClick={props.returnToCardInformation}
          ariaLabelSource={'Update'}
        >
          <SvgUpdate
            css={css`
              transform: scale(calc(14 / 24));
            `}
          />
          {translate('Update')}
        </HoverableLink>
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
            margin-bottom: 8px;
          `}
        >
          {translate('PaymentNet Org ID')}
        </span>
        <span>{props.paymentNetInputPageFlatFields?.paymentNetOrgId}</span>
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
            margin-bottom: 8px;
          `}
        >
          {translate('PaymentNet User ID')}
        </span>
        <span>{props.paymentNetInputPageFlatFields?.paymentNetUserId}</span>
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
            margin-bottom: 8px;
          `}
        >
          {translate('PaymentNet Group ID')}
        </span>
        <span>{props.paymentNetInputPageFlatFields?.paymentGroupId}</span>
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              14,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
            margin-bottom: 8px;
          `}
        >
          {translate('Central Billing Account Last 4 Digits')}
        </span>
        <span>{props.paymentNetInputPageFlatFields?.last4}</span>
      </div>
    </div>
  )
}

export default RegisterAccountCardInfoJPM
